import React, { useState, useEffect } from "react";
import { Form, Switch, Spin, Row, Tooltip } from "antd";
import { QuestionCircleTwoTone } from "@ant-design/icons";
import CaSideNav from "../../../components/AdminComponents/CaSideNav";
import SecondaryNav2 from "../../../components/AdminComponents/SecondaryNav2";
import {
  CaAdminMenu,
  SecondaryNavSettingsCA,
} from "../../../components/AdminComponents/MenuItems";
import Axios from "../../../api/Axios";
import { useSelector } from "react-redux";
import { message } from "antd";
import { getUpdateStatus } from "../../../components/AdminComponents/ViewUpdateIndex";
import LocationInfoModal from "../../../components/LocationInfoModal";
import LoginInfoModal from "../../../components/LoginInfoModal";
import { capitalizeWords } from "../../../components/icons/ApplicationColor";
const ApiSettings = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [data1, setData1] = useState([]);
  const [loading, setLoading] = useState(true);
  const onFinish = (values) => {
    //console.log("Form values:", values);
  };

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const userInfo = useSelector((state) => state.user);
  const updateAuth = getUpdateStatus(userInfo, 1, 1);
  const handleSwitchChange = async (propName, propValue) => {
    try {
      await Axios.put(
        `/organization/${userInfo.data.organization.id}/`,
        { [propName]: propValue }, // Pass the updated prop value based on the switch state
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      //console.log(res);
      UpdateSuccessfull();
    } catch (error) {
      //console.log(error);
      form.setFieldsValue({
        [propName]: !propValue,
      });

      UpdateFailed(error?.response?.data?.detail);
    }
  };
  const UpdateSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Login Access has changed",
      duration: 5,
    });
  };

  const UpdateFailed = (text) => {
    messageApi.open({
      type: "error",
      content: text,
      duration: 5,
    });
  };
  const [form] = Form.useForm();
  const LoadUser = async () => {
    try {
      const res = await Axios.get(
        `/organization/${userInfo.data.organization.id}/`
      );
      setData1(res.data);
      setLoading(false);
      //console.log(res.data);
    } catch (err) {
      //console.log(err);
    }
  };
  useEffect(() => {
    if (!loading && data1) {
      form.setFieldsValue({
        email_login: data1.email_login,
        user_id_login: data1.user_id_login,
        email_and_user_id_login: data1.email_and_user_id_login,
        location_access: data1.location_access,
        is_email_hidden: data1.is_email_hidden,
        is_phone_hidden: data1.is_phone_hidden,
      });
    }
  }, [loading, data1, form]);
  useEffect(() => {
    LoadUser();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const [isModalVisible2, setIsModalVisible2] = useState(false);
  const showModal2 = () => {
    setIsModalVisible2(true);
  };
  const handleCancel2 = () => {
    setIsModalVisible2(false);
  };
  return (
    <CaSideNav props={CaAdminMenu}>
      {contextHolder}
      <SecondaryNav2 menuItems={SecondaryNavSettingsCA} />
      <Spin spinning={loading}>
        <div className="sub-box-conatiner">
          <div className="subscription-box">
            <div
              style={{ display: "flex", justifyContent: "space-between" }}
              className="form-heading"
            >
              {capitalizeWords("LOGIN ACCESS MANAGEMENT")}
            </div>
            <div style={{ padding: "3rem", paddingBottom: "1rem" }}>
              <Form onFinish={onFinish} form={form} disabled={!updateAuth}>
                <Row gutter={0}>
                  <Form.Item
                    label={<p className="my-form-lables">Access By Email</p>}
                  >
                    <Form.Item
                      name="email_login"
                      noStyle
                      initialValue={data1.email_login}
                      valuePropName="checked"
                    >
                      <Switch
                        checkedChildren=" YES "
                        unCheckedChildren=" NO "
                        onChange={(checked) =>
                          handleSwitchChange("email_login", checked)
                        }
                      />
                    </Form.Item>
                  </Form.Item>
                </Row>
                <Row gutter={0}>
                  <Form.Item
                    label={<p className="my-form-lables">Access By User ID</p>}
                  >
                    <Form.Item
                      name="user_id_login"
                      initialValue={data1.user_id_login}
                      valuePropName="checked"
                      noStyle
                    >
                      <Switch
                        checkedChildren=" YES "
                        unCheckedChildren=" NO "
                        onChange={(checked) =>
                          handleSwitchChange("user_id_login", checked)
                        }
                      />
                    </Form.Item>
                  </Form.Item>
                </Row>
                <Row gutter={0}>
                  <Form.Item
                    label={
                      <Tooltip title="Click for more info">
                        <p className="my-form-lables-login" onClick={showModal}>
                          <QuestionCircleTwoTone
                            style={{
                              fontSize: "1.7rem",
                              paddingRight: "0.5rem",
                            }}
                          />
                          Need to use both Email and User ID
                        </p>
                      </Tooltip>
                    }
                  >
                    <Form.Item
                      name="email_and_user_id_login"
                      noStyle
                      initialValue={data1.email_and_user_id_login}
                      valuePropName="checked"
                    >
                      <Switch
                        checkedChildren=" YES "
                        unCheckedChildren=" NO "
                        onChange={(checked) =>
                          handleSwitchChange("email_and_user_id_login", checked)
                        }
                      />
                    </Form.Item>
                  </Form.Item>
                </Row>
                <Row gutter={0}>
                  <Form.Item
                    label={
                      <Tooltip title="Click for more info">
                        <p
                          className="my-form-lables-login"
                          onClick={showModal2}
                        >
                          <QuestionCircleTwoTone
                            style={{
                              fontSize: "1.7rem",
                              paddingRight: "0.5rem",
                            }}
                          />
                          Location Access Mandatory
                        </p>
                      </Tooltip>
                    }
                  >
                    <Form.Item
                      name="location_access"
                      noStyle
                      initialValue={data1.location_access}
                      valuePropName="checked"
                    >
                      <Switch
                        checkedChildren=" YES "
                        unCheckedChildren=" NO "
                        onChange={(checked) =>
                          handleSwitchChange("location_access", checked)
                        }
                      />
                    </Form.Item>
                  </Form.Item>
                </Row>
                <Row gutter={0}>
                  <Form.Item
                    label={<p className="my-form-lables">Hide Email in Directory</p>}
                  >
                    <Form.Item
                      name="is_email_hidden"
                      noStyle
                      initialValue={data1.is_email_hidden}
                      valuePropName="checked"
                    >
                      <Switch
                        checkedChildren=" YES "
                        unCheckedChildren=" NO "
                        onChange={(checked) => {
                          handleSwitchChange("is_email_hidden", checked);
                        }}
                      />
                    </Form.Item>
                  </Form.Item>
                </Row>
                <Row gutter={0}>
                  <Form.Item
                    label={<p className="my-form-lables">Hide Phone Number in Directory</p>}
                  >
                    <Form.Item
                      name="is_phone_hidden"
                      noStyle
                      initialValue={data1.is_phone_hidden}
                      valuePropName="checked"
                    >
                      <Switch
                        checkedChildren=" YES "
                        unCheckedChildren=" NO "
                        onChange={(checked) => {
                          handleSwitchChange("is_phone_hidden", checked);
                        }}
                      />
                    </Form.Item>
                  </Form.Item>
                </Row>
              </Form>
            </div>
          </div>
        </div>
        <LoginInfoModal
          isVisible={isModalVisible}
          handleCancel={handleCancel}
        />
        <LocationInfoModal
          isVisible={isModalVisible2}
          handleCancel={handleCancel2}
        />
      </Spin>
    </CaSideNav>
  );
};

export default ApiSettings;
